export default "__VITE_ASSET__DEXF2XVb__"